export const FaqConstant = {
  // FAQ_CATEGORIES:"",

  FAQ_CATEGORIES_SAGA: "FAQ_CATEGORIES_SAGA",
  FAQ_CATEGORIES_REQUEST: "FAQ_CATEGORIES_REQUEST",
  FAQ_CATEGORIES_RESPONSE: "FAQ_CATEGORIES_RESPONSE",
  FAQ_CATEGORIES_API: "/faq/categories",



  FAQ_CATEGORIES_PARENT_SAGA: "FAQ_CATEGORIES_PARENT_SAGA",
  FAQ_CATEGORIES_PARENT_REQUEST: "FAQ_CATEGORIES_PARENT_REQUEST",
  FAQ_CATEGORIES_PARENT_RESPONSE: "FAQ_CATEGORIES_PARENT_RESPONSE",
  FAQ_CATEGORIES_PARENT_API: "/faq/categories",

  POST_FAQ_CATEGORIES_SAGA: "POST_FAQ_CATEGORIES_SAGA",
  POST_FAQ_CATEGORIES_REQUEST: "POST_FAQ_CATEGORIES_REQUEST",
  POST_FAQ_CATEGORIES_RESPONSE: "POST_FAQ_CATEGORIES_RESPONSE",
  POST_FAQ_CATEGORIES_API: "/faq/category",

  UPDATE_FAQ_CATEGORIES_SAGA: "UPDATE_FAQ_CATEGORIES_SAGA",
  UPDATE_FAQ_CATEGORIES_REQUEST: "UPDATE_FAQ_CATEGORIES_REQUEST",
  UPDATE_FAQ_CATEGORIES_RESPONSE: "UPDATE_FAQ_CATEGORIES_RESPONSE",
  UPDATE_FAQ_CATEGORIES_API: "/faq/category",

  // FAQ CATEGORIES STATUS

  FAQ_CATEGORIES_STATUS_SAGA: "FAQ_CATEGORIES_STATUS_SAGA",
  FAQ_CATEGORIES_STATUS_REQUEST: "FAQ_CATEGORIES_STATUS_REQUEST",
  FAQ_CATEGORIES_STATUS_RESPONSE: "FAQ_CATEGORIES_STATUS_RESPONSE",
  FAQ_CATEGORIES_STATUS_API: "/faq/category/:id",


  FAQ_CATEGORIES_DELETE_SAGA: "FAQ_CATEGORIES_DELETE_SAGA",
  FAQ_CATEGORIES_DELETE_REQUEST: "FAQ_CATEGORIES_DELETE_REQUEST",
  FAQ_CATEGORIES_DELETE_RESPONSE: "FAQ_CATEGORIES_DELETE_RESPONSE",
  FAQ_CATEGORIES_DELETE_API: "/faq/category/:id",

  //Faq

  FAQ_SAGA: "FAQ_SAGA",
  FAQ_REQUEST: "FAQ_REQUEST",
  FAQ_RESPONSE: "FAQ_RESPONSE",
  FAQ_API: "/faqs",

  FAQ_POST_SAGA: "FAQ_POST_SAGA",
  FAQ_POST_REQUEST: "FAQ_REQUEST",
  FAQ_POST_RESPONSE: "FAQ_RESPONSE",
  FAQ_POST_API: "/faq",

  //faq delete
  FAQ_DELETE_SAGA: "FAQ_DELETE_SAGA",
  FAQ_DELETE_REQUEST: "FAQ_DELETE_REQUEST",
  FAQ_DELETE_RESPONSE: "FAQ_DELETE_RESPONSE",
  FAQ_DELETE_API: "/faq/:id",

  FAQ_UPDATE_SAGA: "FAQ_UPDATE_SAGA",
  FAQ_UPDATE_REQUEST: "FAQ_UPDATE_REQUEST",
  FAQ_UPDATE_RESPONSE: "FAQ_UPDATE_RESPONSE",
  FAQ_UPDATE_API: "/faq",

  //kewords store
  //faq-keywords-GET
  GET_FAQ_KEYWORD_SAGA: "GET_FAQ_KEYWORD_SAGA",
  GET_FAQ_KEYWORD_REQUEST: "GET_FAQ_KEYWORD_REQUEST",
  GET_FAQ_KEYWORD_RESPONSE: "GET_FAQ_KEYWORD_RESPONSE",
  GET_FAQ_KEYWORD_API: "/faq/keywords",

  //keywords-post
  POST_FAQ_KEYWORD_SAGA: "POST_FAQ_KEYWORD_SAGA",
  POST_FAQ_KEYWORD_REQUEST: "POST_FAQ_KEYWORD_REQUEST",
  POST_FAQ_KEYWORD_RESPONSE: "POST_FAQ_KEYWORD_RESPONSE",
  POST_FAQ_KEYWORD_API: "/faq/keyword",

  //keywords-update
  UPDATE_FAQ_KEYWORD_SAGA: "UPDATE_FAQ_KEYWORD_SAGA",
  UPDATE_FAQ_KEYWORD_REQUEST: "UPDATE_FAQ_KEYWORD_REQUEST",
  UPDATE_FAQ_KEYWORD_RESPONSE: "UPDATE_FAQ_KEYWORD_RESPONSE",
  UPDATE_FAQ_KEYWORD_API: "/faq/keyword",

  //keywords-delete
  DELETE_FAQ_KEYWORD_SAGA: "DELETE_FAQ_KEYWORD_SAGA",
  DELETE_FAQ_KEYWORD_REQUEST: "DELETE_FAQ_KEYWORD_REQUEST",
  DELETE_FAQ_KEYWORD_RESPONSE: "DELETE_FAQ_KEYWORD_RESPONSE",
  DELETE_FAQ_KEYWORD_API: "/faq/keyword/:id",
};
